import {
  FloatingArrow,
  UseFloatingOptions,
  arrow,
  autoUpdate,
  offset,
  shift,
  useFloating,
  Placement,
  useHover,
  useInteractions,
} from '@floating-ui/react';
import { ReactNode, useRef } from 'react';

const defaultMiddleware = [shift(), offset(8)];

export const TooltipStatic = ({
  isOpen,
  anchor,
  children,
  middleware = defaultMiddleware,
  placement = "top"
}: {
  isOpen: boolean;
  anchor: ReactNode;
  children: ReactNode;
  middleware?: UseFloatingOptions['middleware'];
  placement?: Placement
}) => {
  const arrowRef = useRef(null);

  const { refs, floatingStyles, context } = useFloating({
    whileElementsMounted: autoUpdate,
    open: isOpen,
    placement,
    middleware: [...middleware, arrow({ element: arrowRef })],
  });

  const hover = useHover(context);

  const { getReferenceProps, getFloatingProps} = useInteractions([hover])

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()}>{anchor}</div>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className="rounded-md bg-neutral-700 font-light px-3 py-1 text-neutral-10 xl:max-w-[320px]"
          {...getFloatingProps()}
        >
          <FloatingArrow ref={arrowRef} context={context} className='fill-neutral-700'></FloatingArrow>
          {children}
        </div>
      )}
    </>
  );
};
